/* RESPONSIBLE TEAM: team-fin-voice */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';

export default class StandalonePronunciationsRoute extends Route {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare appService: AppService;

  analytics = {
    section: 'settings',
    place: 'pronunciations',
  };

  get titleToken(): string {
    return this.intl.t('ai-agent.voice-playground.pronunciations-title');
  }

  async beforeModel() {
    if (!this.appService.app.canUseStandaloneDeployPhone) {
      this.router.replaceWith('apps.app.settings.index');
    }
  }
}
